import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import { InfoAlert, Table, SecondaryBtn, SvgCaretDown, SvgCaretUp } from '@tmapy/style-guide';

import { HistoryListItem } from './HistoryListItem';
import { DocHistoryResponse } from '../../openapi/types';

const rightIconDown = { element: <SvgCaretDown />, position: 'right' as const };
const rightIconUp = { element: <SvgCaretUp />, position: 'right' as const };

const msg = defineMessages({
  historyListEmpty: {
    id: 'historyList.empty',
    defaultMessage: 'Historizační záznamy zatím neexistují.',
  },
  showMore: {
    id: 'historyList.showMore',
    defaultMessage: 'Zobrazit starší historii ({count, plural, one {# záznam} few {# záznamy} other {# záznamů}})',
  },
  showLess: {
    id: 'historyList.showLess',
    defaultMessage: 'Skrýt starší historii',
  },
});

type LogListProps = {
  history: DocHistoryResponse[] | undefined;
};

export const HistoryList: React.FC<LogListProps> = React.memo(({ history }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const hasHistory = history && history.length > 0;
  const isExpandable = hasHistory && history.length > 5;
  const visibleHistory = isExpanded ? history : history?.slice(0, 5);

  return (
    <>
      {hasHistory ? (
        <div className='sg-u-box sg-a-o-h dmx-a-mw-fc'>
          <Table>
            <tbody>
              {visibleHistory!.map((historyItem: DocHistoryResponse, idx: number) => (
                <HistoryListItem key={idx} {...historyItem} />
              ))}
            </tbody>
          </Table>

          {isExpandable && (
            <div className='sg-a-p-2 sg-a-d-f sg-a-jc-c'>
              <SecondaryBtn size="sml" icon={isExpanded ? rightIconUp : rightIconDown} onClick={() => setIsExpanded(!isExpanded)}>
                {isExpanded ? (
                  <FormattedMessage {...msg.showLess} />
                ) : (
                  <FormattedMessage {...msg.showMore} values={{ count: history!.length - 5 }} />
                )}
              </SecondaryBtn>
            </div>
          )}
        </div>
      ) : (
        <div className='sg-u-box sg-a-p-2'>
          <InfoAlert>
            <FormattedMessage {...msg.historyListEmpty} />
          </InfoAlert>
        </div>
      )}
    </>
  );
});
